import { renderNotificationLabel } from "./renderNotificationLabel";

interface AllNotifications {
    created_at?: string;
    description?: string;
    is_read?: boolean;
    uuid?: string;
    owner?: string;
}

export const getNotificationOptions = (notifications: AllNotifications[]) => {
    return notifications?.map((notification, id) => {
        return {
            key: `${notification.uuid}-${id}`,
            label: renderNotificationLabel(notification),
        };
    });
};
